import React, { useMemo, useState } from 'react'
import { ErfResponse } from '../../../api/bridgingFinance/searchPropertyByErf'
import {
  FullTitle,
  PropertySearchByOwnerResponse,
  SectionalTitle,
} from '../../../api/bridgingFinance/searchPropertyByOwner'
import '../SearchResultsTable.css'
import { EmptyMessage } from '../../kyc/EmptyMessage'

export interface PropertyByOwnerNameResultsTableProps {
  entries?: PropertySearchByOwnerResponse | null
  title: string
  onFullTitleRowClick?: (row: FullTitle) => void
  onSectionalTitleRowClick?: (row: SectionalTitle) => void
}

export const PropertyByOwnerNameResultsTable: React.FC<
  PropertyByOwnerNameResultsTableProps
> = ({ entries, title, onFullTitleRowClick, onSectionalTitleRowClick }) => {
  const handleFullTitleClick = (erf: FullTitle) => () => {
    if (onFullTitleRowClick) onFullTitleRowClick(erf)
  }
  const handleSectionalTitleClick = (erf: SectionalTitle) => () => {
    if (onSectionalTitleRowClick) onSectionalTitleRowClick(erf)
  }

  const [titleType, setTitleType] = useState<'FULL' | 'SECTIONAL'>('FULL')

  const showEmpty = useMemo(
    () =>
      !entries ||
      (titleType === 'FULL' && entries.fullTitleCount === 0) ||
      (titleType === 'SECTIONAL' && entries.sectionalTitleCount === 0),
    [entries],
  )

  if (entries === undefined) return null

  return (
    <div className="kyc-bf-results-table-container">
      <h3 className="table-title">{title}</h3>
      <div className="buttons">
        <div
          className={`tab-button ${titleType === 'FULL' ? 'active' : ''}`}
          onClick={() => setTitleType('FULL')}
        >
          Full Title {`(${entries?.fullTitleCount ?? 0})`}
        </div>
        <div
          className={`tab-button ${titleType === 'SECTIONAL' ? 'active' : ''}`}
          onClick={() => setTitleType('SECTIONAL')}
        >
          Sectional Title {`(${entries?.sectionalTitleCount ?? 0})`}
        </div>
      </div>
      <table>
        {titleType === 'FULL' && (
          <thead>
            <tr style={{ height: '40px' }}>
              <th>Owner</th>
              <th style={{ width: '70px' }}>ERF #</th>
              <th style={{ width: '70px' }}>Street #</th>
              <th>Address</th>
              <th>Suburb</th>
              {/* <th>Allotment</th>
            <th>CMA ID</th> */}
            </tr>
          </thead>
        )}
        {titleType === 'SECTIONAL' && (
          <thead>
            <tr style={{ height: '40px' }}>
              <th>Owner</th>
              <th style={{ width: '70px' }}>Section #</th>
              <th style={{ width: '100px' }}>Scheme #</th>
              <th>Scheme Name</th>
              <th>Address</th>
              <th>Suburb</th>
              {/* <th>Municipality Name</th> */}
              {/* <th>Allotment</th>
            <th>CMA ID</th> */}
            </tr>
          </thead>
        )}
        <tbody>
          {showEmpty && <EmptyMessage />}
          {titleType === 'FULL' &&
            entries?.fullTitles.map((entry, index) => (
              <tr
                key={index}
                onClick={handleFullTitleClick(entry)}
                style={{ height: '30px' }}
              >
                <td>{entry.owner}</td>
                <td style={{ width: '70px' }}>{entry.erfNo}</td>
                <td style={{ width: '70px' }}>{entry.streetNo}</td>
                <td>{entry.address}</td>
                <td>{entry.suburb}</td>
                {/* <td>{entry.municipalityName || '-'}</td> */}
                {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
              </tr>
            ))}
          {titleType === 'SECTIONAL' &&
            entries?.sectionalTitles.map((entry, index) => (
              <tr
                key={index}
                onClick={handleSectionalTitleClick(entry)}
                style={{ height: '30px' }}
              >
                <td>{entry.owner}</td>
                <td style={{ width: '70px' }}>{entry.sectionNo}</td>
                <td style={{ width: '100px' }}>{entry.schemeNo}</td>
                <td>{entry.schemeName}</td>
                <td>{entry.address}</td>
                <td>{entry.suburb}</td>
                {/* <td>{entry.municipalityName || '-'}</td> */}
                {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}
